import { MachineAttribute } from '@internal/utils/machine/MachineAttribute'
import {
  MachineSubType,
  MachineType,
} from '@internal/utils/machine/MachineType'
import { TFilterableBaleChamberOption } from '@internal/utils/search/TFilterableBalerChamberOption'
import { TFilterableHeaderTypeOption } from '@internal/utils/search/TFilterableHeaderTypeOption'
import { z } from 'zod'
import { SearchResultsSortKey } from './SearchResultsSortKey'
import { TRangeFiltersMap } from './TRangeFiltersMap'

export type SearchModel = {
  name: string
  type: 'fuzzy' | 'mapped' | 'base' | 'series'
}

export const mappedModelSuffix = '-mapped'

export enum SearchTag {
  HotDeals = 'hot-deals',
}

export const SearchTagSchema = z.nativeEnum(SearchTag)
export const SearchTagsSchema = z.array(SearchTagSchema)

export type TSearchParams = {
  tags: SearchTag[]
  models: SearchModel[]
  brands: string[]
  machineType: MachineType | undefined
  machineSubType: MachineSubType | undefined
  baleChamber: TFilterableBaleChamberOption | undefined
  headerType: TFilterableHeaderTypeOption | undefined
  amount: number
  features: MachineAttribute[]
  rangeFilters: TRangeFiltersMap
  locations: string[]
  sort: SearchResultsSortKey
}
